import { render, staticRenderFns } from "./PromoBar.vue?vue&type=template&id=0cea8246&scoped=true&lang=pug"
import script from "./PromoBar.vue?vue&type=script&lang=js"
export * from "./PromoBar.vue?vue&type=script&lang=js"
import style0 from "./PromoBar.vue?vue&type=style&index=0&id=0cea8246&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea8246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cea8246')) {
      api.createRecord('0cea8246', component.options)
    } else {
      api.reload('0cea8246', component.options)
    }
    module.hot.accept("./PromoBar.vue?vue&type=template&id=0cea8246&scoped=true&lang=pug", function () {
      api.rerender('0cea8246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/navigation/PromoBar.vue"
export default component.exports